import appsignal from "lib/appsignal";
import Table2Borders from "state/ui/editor/designAdapter/Table2Borders";

interface CellMetadataLike {
  uniqueId?: string;
  borders?: unknown;
}

type Table2BordersConstructorArg = ConstructorParameters<
  typeof Table2Borders
>[0];

let hasReportedContractViolation = false;

const shapeOf = (value: unknown): string => {
  if (value === null) return "null";
  if (Array.isArray(value)) return "array";
  return typeof value;
};

const reportContractViolation = (cellMetadata: CellMetadataLike): void => {
  if (hasReportedContractViolation) return;
  hasReportedContractViolation = true;
  try {
    appsignal.sendError(
      new Error(
        "Table2Cell received non-Table2Borders value for cellMetadata.borders"
      ),
      span => {
        span.setAction("Table2Cell.resolveCellBorders.contractViolation");
        const borders = cellMetadata.borders as
          | Record<string, unknown>
          | null
          | undefined;
        span.setTags({
          cellUniqueId: String(cellMetadata.uniqueId ?? ""),
          bordersShape: shapeOf(borders),
          bordersKeys:
            borders && typeof borders === "object"
              ? Object.keys(borders).slice(0, 8).join(",")
              : ""
        });
      }
    );
  } catch {
    /* telemetry must never break the render */
  }
};

export const resolveCellBorders = (
  cellMetadata: CellMetadataLike
): Table2Borders => {
  const borders = cellMetadata.borders;
  if (borders instanceof Table2Borders) return borders;

  reportContractViolation(cellMetadata);

  const constructorArg =
    borders && typeof borders === "object" && !Array.isArray(borders)
      ? (borders as Table2BordersConstructorArg)
      : undefined;
  // Last-ditch fallback: even with the typeof+!isArray filter, a per-side
  // value that throws on spread (non-spreadable proxy, getter that throws,
  // etc.) would crash Table2Borders' constructor. The whole premise of this
  // helper is "never let one bad cell white-screen the editor", so wrap the
  // construction itself and fall back to defaults on any exception. The cost
  // on the healthy path is zero — try/catch only fires on the cold branch.
  try {
    return new Table2Borders(constructorArg);
  } catch {
    return new Table2Borders();
  }
};
